import moment from "moment";

const address =
  "erd1lreq35jskm5dkd9zrgzhynyxxwnhewukd45r2nxvhw0qvszrq4csacuev6";

const vaultAddress =
  "erd1mx3j08h4ypuuqtrp5nvhthm4c48cg6r6ude8fah7t3m8elyjvcrsxt5lyt";

const mnemonics = [
  "valid",
  "impulse",
  "siege",
  "humor",
  "steel",
  "theory",
  "inside",
  "firm",
  "law",
  "armed",
  "beach",
  "school",
  "diary",
  "tragic",
  "onion",
  "super",
  "room",
  "age",
  "tennis",
  "onion",
  "cradle",
  "together",
  "ostrich",
  "focus",
];

/*
 *  Self-invoking function with the purpose of handling the phrase revealing functionality.
 */

(() => {
  const button = document.getElementById("secret-phrase");

  button.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    button.classList.toggle("active");
  });
})();

/*
 *  Self-invoking function with the purpose of handling the phrase copy functionality.
 */

(() => {
  const copyMnemonics = document.getElementById("phrase-copy-mnemonics");
  const copyAddress = document.getElementById("phrase-copy-address");
  const copyVaultAddress = document.getElementById("phrase-vault-address");
  const words = mnemonics.join(" ").trim();

  const copyButtons = [
    { element: copyMnemonics, string: words },
    { element: copyAddress, string: address },
    { element: copyVaultAddress, string: vaultAddress },
  ];

  copyButtons.forEach((button) => {
    button.element.addEventListener("click", (event) => {
      event.preventDefault();
      button.element.classList.add("copied");
      navigator.clipboard.writeText(button.string);

      setTimeout(() => {
        button.element.classList.remove("copied");
      }, 2000);
    });
  });
})();

/*
 *  Self-invoking function with the purpose of handling the countdown functionality.
 */

(() => {
  const timestamp = 1686920400;
  const genesis = moment.unix(timestamp);
  const countdown = document.getElementById("countdown");

  const assignTime = () => {
    const present = moment().unix();
    const counter = genesis.valueOf() / 1000 - present;
    const duration = moment.duration(counter, "seconds");

    if (duration.isValid() && duration.asSeconds() >= 0) {
      const days = Math.floor(duration.asDays());

      const formatters = [
        ["days", days > 9 ? days : `0${days}`],
        ["hours", "HH"],
        ["minutes", "mm"],
        ["seconds", "ss"],
      ];

      const format = (key) =>
        moment
          .utc(moment.duration(counter, "seconds").asMilliseconds())
          .format(`${key}`);

      const values = formatters.reduce(
        (total, [label, key]) =>
          Object.assign(total, {
            [label]: format(key),
          }),
        {}
      );

      formatters.forEach(([identifier]) => {
        Object.assign(document.getElementById(identifier), {
          innerText: values[identifier],
        });
      });
    }
  };

  if (countdown) {
    const updateTimerInterval = setInterval(() => {
      if (genesis.valueOf() / 1000 > moment().unix()) {
        assignTime();
      } else {
        clearInterval(updateTimerInterval);
      }
    }, 1000);

    assignTime();
  }
})();
